<template>
  <div class="operate_center blue">
    <door-box :height="812" width="100%">
     <div class="top">
       <div class="t_title">
         超低新技术应用
       </div>
       <technology></technology>
     </div>
      <div class="bottom">
        <operateWork></operateWork>
      </div>
    </door-box>
  </div>
</template>

<script>
import doorBox from '../components/doorBox';
import operateWork from './component/operateWork';
import technology from './component/technologyApplication';
export default {
  name: 'index',
  components: {doorBox,operateWork,technology}
}
</script>

<style lang="scss" scoped>
.operate_center {
  height: 100%;
  margin-left: 20px;
  .isBaoSteel {
    background: #020F3F;
  }
  .box_wrap {
    height: 100%;
  }
  .top {
    padding-top: 10px;
    padding-left: 10px;
    height: 49%;
    @include bg-box(100%, 49%, 'center_top.png');
    margin-bottom: 10px;
    position: relative;
    transition: none 0s ease 0s;
    .t_title {
      position: absolute;
      top: 20px;
      left: 20px;
      font-size: 30px;
      font-weight: 600;
      color: #63F2EF;
    }
  }
  .bottom {
    height: 50%;
    padding-top: 10px;
    padding-left: 10px;
    @include bg-box(100%, 50%, 'center_bottom.png');
    transition: none 0s ease 0s;
  }
}
.blue {
  //background: rgba(0, 106, 255, 0.05);
  border: 1px solid rgba(132, 170, 255, 0.5);
}
</style>
